/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Save_As_Template_DescriptionInputs */



/**
* | output |
* | --- |
* | "Capture this project's instructions, chats, and their personas as a reusable template. Chats are saved empty (no message history)." |
*
* @param {Templates_Save_As_Template_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const templates_save_as_template_description = /** @type {((inputs?: Templates_Save_As_Template_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Save_As_Template_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erfasse die Anweisungen, Chats und deren Personas dieses Projekts als wiederverwendbare Vorlage. Chats werden leer gespeichert (kein Nachrichtenverlauf).")
	return /** @type {LocalizedString} */ ("Capture this project's instructions, chats, and their personas as a reusable template. Chats are saved empty (no message history).")
});